import { ShippingMethod } from "../../ShippingMethod";
import { getIsFreightDeliverr } from "./getIsFreightDeliverr";
import { getIsFreightExternal } from "./getIsFreightExternal";

export const getIsFreight = (shippingMethod?: ShippingMethod): boolean =>
  getIsFreightDeliverr(shippingMethod) || getIsFreightExternal(shippingMethod);
